import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {ReportRequest} from "../api";

export class ReportsService extends RestService<ReportRequest> {
    constructor(url: string) {
        if (!url) {
            super(REST_API_END_POINTS.REPORTS)
        } else {
            super(url)
        }
    }
}
